import { NgModule } from '@angular/core';
import { MsInputTextModule } from './components/ms-input-text/ms-input-text.module';
import { MsButtonModule } from './components/ms-button/ms-button.module';
import { MsInputPasswordModule } from './components/ms-input-password/ms-input-password.module';
import { MsSelectModule } from './components/ms-select/ms-select.module';
import { MsSelectLanguageModule } from './components/ms-select-language/ms-select-language.module';
import { MsColorPickerModule } from './components/ms-color-picker/ms-color-picker.module';
import { MsBreadcrumbsModule } from './components/ms-breadcrumbs/ms-breadcrumbs.module';
import { MsInputSwitchModule } from './components/ms-input-switch/ms-input-switch.module';
import { MsTabModule } from './components/ms-tab/ms-tab.module';
import { MsTabsModule } from './components/ms-tabs/ms-tabs.module';
import { MsPasswordStrengthBarModule } from './components/ms-password-strength-bar/ms-password-strength-bar.module';
import { MsLogoModule } from './components/ms-logo/ms-logo.module';
import { MsContentModule } from './components/ms-content/ms-content.module';
import { MsAvatarModule } from './components/ms-avatar/ms-avatar.module';
import { MsEmptyModule } from './components/ms-empty/ms-empty.module';
import { MsCheckboxModule } from './components/ms-checkbox/ms-checkbox.module';
import { MsInputTextareaModule } from './components/ms-input-textarea/ms-input-textarea.module';
import { MsButtonSpeedDialModule } from './components/ms-button-speed-dial/ms-button-speed-dial.module';
import { MsOverlayPanelModule } from './components/ms-overlay-panel/ms-overlay-panel.module';
import { MsListboxModule } from './components/ms-listbox/ms-listbox.module';
import { MsMenuModule } from './components/ms-menu/ms-menu.module';
import { MsTableOldModule } from './components/ms-table-old/ms-table-old.module';
import { MsTableModule } from './components/ms-table/ms-table.module';
import { MsContentFormModule } from './components/ms-content-form/ms-content-form.module';
import { MsDialogErrorModule } from './components/ms-dialog-error/ms-dialog-error.module';
import { NavigationSelectModule } from '../modules/admin/navigation/select/navigationSelect.module';

@NgModule({
	exports: [
		MsInputTextModule,
		MsInputPasswordModule,
		MsButtonModule,
		MsSelectModule,
		MsSelectLanguageModule,
		MsColorPickerModule,
		MsTableOldModule,
		MsTableModule,
		MsBreadcrumbsModule,
		MsInputSwitchModule,
		MsTabModule,
		MsTabsModule,
		MsPasswordStrengthBarModule,
		MsLogoModule,
		MsContentModule,
		MsAvatarModule,
		MsMenuModule,
		MsEmptyModule,
		MsCheckboxModule,
		MsInputTextareaModule,
		MsButtonSpeedDialModule,
		MsOverlayPanelModule,
		MsListboxModule,
		MsContentFormModule,
		MsDialogErrorModule,

		//Application Custom
		NavigationSelectModule,
	],
})
export class SharedLibsInternalModule {}
